module.exports = __webpack_public_path__ + "static/media/cityscapes.2e01ff43.jpg";